import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { StyledTable } from '../../components';
import { connect } from 'react-redux';
import TableActionsBar, {
	GradientButton,
} from '../../components/TableActionBar/TableActionBar';
import {
	fetchProcessedAgsns,
	partTakeIn,
} from '../../redux/actionCreators/station';
import { receivePart } from '../../redux/actionCreators/receivePart';
import { useNavigate } from 'react-router-dom';
import { useMessageContextManager } from '../../components/MessageOverlay/MessageOverlay';

const inProgressColumn = [
	{
		title: 'VIN',
		field: 'serialNumber',
		width: 160,
		sortable: true,
		align: 'center'
	},
	{
		title: 'ID',
		field: 'displaySequenceNumber',
		width: 100,
		sortable: true,
		align: 'center'
	},
	{
		title: 'KESPEC NUMBER',
		field: 'partNumber',
		width: 160,
		sortable: true,
		align: 'center'
	},
	{
		title: 'KESPEC DESCRIPTION',
		field: 'description',
		width: 200,
		sortable: true,
		align: 'center'
	},
	{
		title: 'DATE',
		field: 'productionDt',
		width: 140,
		sortable: true,
		align: 'center'
	},
];



const mapDispatchToProps = (dispatch) => ({
	fetchProcessedAgsns: (successCallback, errorCallback) =>
		dispatch(fetchProcessedAgsns(successCallback, errorCallback)),
	partTakeIn: (sequenceNumber, successCallback, errorCallback) =>
		dispatch(partTakeIn(sequenceNumber, null, successCallback, errorCallback)),
	receivePart: (serialNumber, successCallback, errorCallback) =>
		dispatch(receivePart(serialNumber, successCallback, errorCallback)),
});

export const ProcessedPage = ({
	fetchProcessedAgsns,
	partTakeIn,
	receivePart,
}) => {
	const navigate = useNavigate();
	const { showMessageOverlay } = useMessageContextManager();
	const [selectedPvRows, setSelectedPvRows] = useState(null);
	const [selectedRowData, setSelectedRowData] = useState([]);
	const [inProgressRow, setInprogressRow] = useState();
	const [filters, setFilters] = useState({});
	const [columns, setColumns] = useState(inProgressColumn);

	const onPartNumberSubmit = () => {
		if (!selectedRowData?.sequenceNumber) return;

		const closeLoading = showMessageOverlay({
			contextText: 'Taking In...',
			loading: true,
		});

		partTakeIn(
			selectedRowData?.sequenceNumber,
			() => {
				closeLoading();
				const closeSuccess = showMessageOverlay({
					contextText: 'Success',
					info: 'Part Taken In successfully',
					success: true,
				});

				setTimeout(() => {
					closeSuccess();
					navigate('/');
				}, 2000);
			},
			(error) => {
				closeLoading();
				showMessageOverlay({
					contextText: 'Error',
					info: error?.response?.data?.message || 'Failed to take in part',
					error: true,
				});
			},
		);
	};

	const getData = async () => {
		fetchProcessedAgsns(
			(data) => {
				setInprogressRow(
					data.map((row) => ({
						...row,
						id: row.sequenceNumber,
						readyForDropSequenceNumber: row.metaData.readyForDropSequenceNumber,
						vcDescription: row.metaData.vcDescription,
						vcSequenceNumber: row.metaData.vcSequenceNumber,
						vcPartNumber: row.metaData.vcPartNumber,
						shiftLabel: row.metaData.shiftLabel,
						vcNumber: row.metaData.vcNumber,
						majorModel: row.metaData.majormodel,
						country: row.metaData.country,
					})),
				);
			},
			(error) => console.log(error),
		);
	};
	useEffect(() => {
		getData();
	}, []);
	const handleSelectionChange = (selectedIds, row) => {
		setSelectedPvRows(selectedIds);
		setSelectedRowData(row);
	};
	return (
		<Box sx={{ height: '100%', padding: "0.5vw 1vw" }}>
			<TableActionsBar
				showColumns
				showFilter
				showExport={true}
				columns={columns || []}
				rows={inProgressRow || []}
				defaultColumns={[...inProgressColumn]}
				onColumnChange={setColumns}
				onFilterChange={(filters) => setFilters(filters)}
			/>
			<StyledTable
				showCheckBox
				onSelectionChange={handleSelectionChange}
				selectedRows={selectedPvRows}
				columns={columns || []}
				rows={inProgressRow || []}
				filters={filters}
				elevated
				isRowClickCopy={true}
			/>
			<div style={{ display: 'flex', justifyContent: 'end', marginTop: "1vw" }}>
				<GradientButton
					gradient="linear-gradient(90deg, #435C42 0%, #619C31 100%)"
					onClick={onPartNumberSubmit}
					disabled={!selectedPvRows || selectedPvRows.length === 0}
				>
					Take In
				</GradientButton>
			</div>
		</Box>
	);
};

export default connect(null, mapDispatchToProps)(ProcessedPage);
